import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const CollectionsTranslations = wrapTranslationsSchema({
	name: 'CollectionsTranslations',
	title: 'Collections Translations',
	sanityId: 'collections',
	fields: {
		collectionType: 'Collection',
		collectionItems: 'Solutions',
	},
});
